




















import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({})
export default class VInputWithDropdown extends Vue {
  @Prop({ default: () => [] }) options!: string[];
  @Prop({ default: "" }) value!: string;

  currentValue: string = "";

  @Watch("value")
  changeValue(newValue: string) {
    this.currentValue = newValue;
  }

  select(newValue: string) {
    this.changeValue(newValue);
    this.$emit("input", newValue);
  }
}
